"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconTypeOfBuildingOutline = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 22",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10,0.5 L10,2.76 L12,4.09 L12,2.5 L22,2.5 L22,17.5 L17,17.5 L17,19.5 L24,19.5 L24,0.5 L10,0.5 M7.5,3.5 L0,8.5 L0,19.5 L15,19.5 L15,8.5 L7.5,3.5 M14,4.5 L14,5.43 L15.61,6.5 L16,6.5 L16,4.5 L14,4.5 M18,4.5 L18,6.5 L20,6.5 L20,4.5 L18,4.5 M7.5,6 L13,9.5 L13,17.5 L10,17.5 L10,11.5 L5,11.5 L5,17.5 L2,17.5 L2,9.5 L7.5,6 M18,8.5 L18,10.5 L20,10.5 L20,8.5 L18,8.5 M18,12.5 L18,14.5 L20,14.5 L20,12.5 L18,12.5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconTypeOfBuildingOutline')(IconTypeOfBuildingOutline);